var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7778 9.85C20.7778 5.63125 18.3778 4 15.9889 4C13.9444 4 12.9111 4.6525 11.8889 5.94625C10.8667 4.6525 9.83333 4 7.78889 4C5.4 4 3 5.62 3 9.85C3 13.1125 6.75556 17.635 11.8778 19.75C17 17.635 20.7556 13.1125 20.7556 9.85H20.7778Z",
    stroke: "#A6A6A6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicGrey);
export default __webpack_public_path__ + "static/media/PIC_grey.9bd273941c159a315a4b563c5171382f.svg";
export { ForwardRef as ReactComponent };